import React, { useEffect, useState } from "react";
import { waitForPreviewSimulation } from "./previewSimulation";

export const PREVIEW_COUPON_DISCOUNT_RATE = 0.10;

const fieldStyle = {
  border: "1px solid var(--zyvgo-border, #d1d5db)",
  borderRadius: 8,
  boxSizing: "border-box",
  fontSize: 16,
  padding: "12px 14px",
  width: "100%",
};

export default function PreviewPaymentFields({ onDiscountRateChange = () => {} }) {
  const [couponCode, setCouponCode] = useState("");
  const [couponApplied, setCouponApplied] = useState(false);
  const [couponApplying, setCouponApplying] = useState(false);

  useEffect(() => {
    onDiscountRateChange(0);
  }, [onDiscountRateChange]);

  const handleApplyCoupon = async () => {
    if (!couponCode.trim() || couponApplying) return;
    setCouponApplied(false);
    onDiscountRateChange(0);
    setCouponApplying(true);
    await waitForPreviewSimulation();
    setCouponApplied(true);
    onDiscountRateChange(PREVIEW_COUPON_DISCOUNT_RATE);
    setCouponApplying(false);
  };

  return (
    <div aria-label="Simulated payment form" style={{ display: "grid", gap: 12 }}>
      <div style={{ padding: 10, borderRadius: 8, background: "#fff7ed", color: "#9a3412", fontSize: 13 }}>
        Preview only — payment details are simulated and never transmitted or stored.
      </div>
      <div aria-label="Simulated coupon form" style={{ display: "grid", gap: 6 }}>
        <label htmlFor="preview-coupon-code">Have a coupon code?</label>
        <div style={{ display: "grid", gridTemplateColumns: "minmax(0, 1fr) auto", gap: 8 }}>
          <input
            id="preview-coupon-code"
            type="text"
            value={couponCode}
            disabled={couponApplying}
            onChange={(event) => {
              setCouponCode(event.target.value);
              setCouponApplied(false);
              onDiscountRateChange(0);
            }}
            placeholder="Enter coupon code"
            style={fieldStyle}
          />
          <button
            type="button"
            onClick={handleApplyCoupon}
            disabled={couponApplying || !couponCode.trim()}
            style={{
              border: "1px solid #0f766e",
              borderRadius: 8,
              background: "#0f766e",
              color: "#fff",
              cursor: couponApplying ? "wait" : "pointer",
              fontWeight: 600,
              padding: "0 14px",
            }}
          >
            {couponApplying ? "Applying…" : "Apply"}
          </button>
        </div>
        {couponApplied && (
          <div role="status" style={{ color: "#166534", fontSize: 13 }}>
            ✓ Coupon applied: 10% off
          </div>
        )}
      </div>
      <label>
        <span style={{ display: "block", marginBottom: 6 }}>Card number</span>
        <input style={fieldStyle} inputMode="numeric" placeholder="4242 4242 4242 4242" />
      </label>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
        <label><span style={{ display: "block", marginBottom: 6 }}>Expiry</span><input style={fieldStyle} placeholder="MM/YY" /></label>
        <label><span style={{ display: "block", marginBottom: 6 }}>CVC</span><input style={fieldStyle} placeholder="CVC" /></label>
        <label><span style={{ display: "block", marginBottom: 6 }}>ZIP</span><input style={fieldStyle} placeholder="ZIP" /></label>
      </div>
    </div>
  );
}
